export class Priority {
    Code: string;
    Name: string;
  }